module.exports = __webpack_public_path__ + "static/media/POSTAWA.9d3e4323.png";